export default "<span class=\"icon\">\n  <app-order-status-icon [orderStatus]=\"orderStatus\"></app-order-status-icon>\n</span>"